import { c as _c } from "react/compiler-runtime";
import { twJoin } from 'tailwind-merge';
interface AnimatedMenuIconProps {
  open: boolean;
}
export function AnimatedMenuIcon(t0) {
  const $ = _c(16);
  const {
    open
  } = t0;
  const t1 = open ? "translate-y-0 rotate-45" : "-translate-y-1.25 rotate-0";
  let t2;
  if ($[0] !== t1) {
    t2 = twJoin("bg-current text-icon-primary transition-base block h-full w-full rounded-full transition-[transform,translate,scale,rotate,opacity]", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <span className="absolute top-1/2 left-1/2 h-0.5 w-4 -translate-x-1/2 -translate-y-1/2"><span className={t2} /></span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = open ? "scale-x-50 opacity-0" : "scale-x-100 opacity-100";
  let t5;
  if ($[4] !== t4) {
    t5 = twJoin("bg-current text-icon-primary transition-base block h-full w-full rounded-full transition-[transform,translate,scale,rotate,opacity]", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <span className="absolute top-1/2 left-1/2 h-0.5 w-4 -translate-x-1/2 -translate-y-1/2"><span className={t5} /></span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = open ? "translate-y-0 -rotate-45" : "translate-y-1.25 rotate-0";
  let t8;
  if ($[8] !== t7) {
    t8 = twJoin("bg-current text-icon-primary transition-base block h-full w-full rounded-full transition-[transform,translate,scale,rotate,opacity]", t7);
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <span className="absolute top-1/2 left-1/2 h-0.5 w-4 -translate-x-1/2 -translate-y-1/2"><span className={t8} /></span>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t3 || $[13] !== t6 || $[14] !== t9) {
    t10 = <span aria-hidden={true} className="relative block size-5">{t3}{t6}{t9}</span>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}